// extracted by mini-css-extract-plugin
export var chevron = "_31-2";
export var chevronCollapsed = "_31-3";
export var collapsibleHeader = "_31-1";
export var container = "_31-0";